/**
 * Q&A cards — Read More / Read Less (one listener for whole store; safe if script loads twice).
 */
(function () {
  if (window.__qaCardsReadMoreInit) return;
  window.__qaCardsReadMoreInit = true;

  function handleToggle(btn) {
    var targetId = btn.getAttribute('data-qa-target');
    if (!targetId) return;
    var target = document.getElementById(targetId);
    if (!target) return;

    var expanded = btn.getAttribute('aria-expanded') === 'true';
    var parent = btn.closest('.qa-cards__answer-preview');

    if (expanded) {
      target.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      if (parent) parent.classList.remove('qa-cards__answer-preview--open');
    } else {
      target.classList.add('is-open');
      btn.setAttribute('aria-expanded', 'true');
      if (parent) parent.classList.add('qa-cards__answer-preview--open');
    }
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button.qa-cards__toggle[data-qa-target]');
    if (!btn) return;
    e.preventDefault();
    handleToggle(btn);
  });
})();
